import React from 'react';
import { Modal, Box, Paragraph, Stack, Text } from '@thecb/components';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  holdOrderRequest,
  selectHasSuccessfulPayments,
} from '../../pages/cart/Cart.state';
import {
  dismissVisitExpirationWarning,
  visitExpired,
} from '../../pages/cart/VisitExpiration.state';

const EmptyBox = () => <Box padding="0" />;
const noop = () => {};

const VisitExpirationModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isWarningVisible, secondsRemaining } = useSelector(
    (state) => state.visitExpiration,
  );
  const orderId = useSelector((state) => state.cart?.order?.order_id);
  const hasSuccessfulPayments = useSelector(selectHasSuccessfulPayments);

  if (!isWarningVisible) return null;

  const handleHoldOrder = () => {
    dispatch(dismissVisitExpirationWarning());
    dispatch(holdOrderRequest({ navigate }));
  };

  const handleCancelOrder = () => {
    dispatch(visitExpired());
  };

  const handleDismiss = () => {
    dispatch(dismissVisitExpirationWarning());
  };

  const seconds = (
    <Text weight="600">{`${secondsRemaining} ${secondsRemaining === 1 ? 'second' : 'seconds'}`}</Text>
  );

  const modalBody = (
    <Box padding="0">
      <Stack>
        <Paragraph>
          Order <Text weight="600">{orderId}</Text> will expire in {seconds}.
          {hasSuccessfulPayments
            ? ' Please complete the order or void the payments and cancel the order.'
            : ' You can put the order on hold to retain the order or cancel the order.'}
        </Paragraph>
      </Stack>
    </Box>
  );

  const modalExtraProps = {
    ModalLink: EmptyBox,
    modalHeaderText: 'Your order is about to expire!',
    modalBodyText: modalBody,
    ...(hasSuccessfulPayments
      ? {
          onlyCloseButton: true,
          closeButtonText: 'Dismiss',
          hideModal: handleDismiss,
        }
      : {
          continueButtonText: 'Cancel Order',
          cancelButtonText: 'Place Order on Hold',
          continueAction: handleCancelOrder,
          cancelAction: handleHoldOrder,
        }),
  };

  return (
    <Modal
      showModal={noop}
      hideModal={noop}
      modalOpen={isWarningVisible}
      defaultWrapper={false}
      underlayClickExits={false}
      {...modalExtraProps}
    >
      <EmptyBox />
    </Modal>
  );
};

export default VisitExpirationModal;
